import * as React from 'react';

export const useDraggableContainer = (scrollRef: any, itemsWidthWiderThanWindow: boolean) => {
    const [position, setPosition] = React.useState<{top: number, left: number, x: number, y: number}>({top: 0, left: 0, x: 0, y: 0})
    const [isDragging, setIsDragging] = React.useState(false)

    const mouseDownHandler = (e: any) => {
        scrollRef.current.style.cursor = 'grabbing'
        scrollRef.current.style.userSelect = 'none'

        setPosition({left: scrollRef?.current?.scrollLeft,
            top: scrollRef?.current?.scrollTop,
            x: e.clientX,
            y: e.clientY
        })
        setIsDragging(true)
    }

    const mouseMoveHandler = (e: any) => {
        setIsDragging(true)
        const mouseMoveX = e.clientX - position.x
        const mouseMoveY = e.clientY - position.y

        scrollRef.current.scrollLeft = position.left - mouseMoveX
        scrollRef.current.scrollTop = position.top- mouseMoveY
    }

    const mouseUpHandler = () => {
        if (itemsWidthWiderThanWindow) scrollRef.current.style.cursor = 'grab'
        scrollRef?.current?.style.removeProperty('user-select')
        setIsDragging(false)
    }

    React.useEffect(()=>{
        if(isDragging) document.addEventListener('mousemove', mouseMoveHandler)
        return () => document.removeEventListener('mousemove', mouseMoveHandler)
    }, [isDragging])

    return {position, setPosition, mouseDownHandler, mouseMoveHandler, mouseUpHandler}
}